import { z } from 'zod'

export const signInInputSchema = z.object({
  email: z.string().email({ message: 'Please enter a valid email address.' }),
  password: z
    .string({
      required_error: 'Password is required.',
    })
    .nonempty({ message: 'Password is required.' })
    .min(8, { message: 'Minimum 8 characters.' }),
  confirmPassword: z.string({
      required_error: 'Confirm password is required.',
    })
    .nonempty({ message: 'Confirm password is required.' }),
  oldPassword: z
    .string({
      required_error: 'Password is required.',
    })
    .nonempty({ message: 'Password is required.' }),
  code: z.string().length(6, { message: 'Verification code must be 6 digits' }),
})
